import React from 'react'
import PropTypes from 'prop-types'
import branding from 'shared/branding'
import { CNG, CSH } from 'constants/values'
import PreApproved from 'shared/images/preApproved.svg'

export const OnlineInStoreBadge = ({ visible = false, productCode, onlineOnly, text }) => {
  if (!visible) return null
  const brand = branding.current.key
  const backgroundColor = brand === CNG ? '#C0DEBA' : '#6251A1'
  let verbiage
  if (text) {
    verbiage = text
  } else {
    const isOnlineOnly = typeof onlineOnly === 'boolean' ? onlineOnly : productCode === 'PDL'
    verbiage = isOnlineOnly ? 'Online Only' : 'Online & In-store'
  }
  return (
    <span className={`badge online-instore-badge ${brand === CSH ? 'text-white' : ''}`} style={{ backgroundColor }}>{verbiage}</span>
  )
}

OnlineInStoreBadge.propTypes = {
  visible: PropTypes.bool,
  productCode: PropTypes.string,
  onlineOnly: PropTypes.bool,
  text: PropTypes.string,
}

export const PreApprovedBadge = ({ visible = false, text, icon, darkText = false, productCode: _productCode, onlineOnly: _onlineOnly }) => {
  if (!visible) return null
  const verbiage = text || 'You Are Preapproved'

  return (
    <span className={`badge bg-primary preapproved-badge ${darkText ? 'text-dark' : 'text-white'}`} style={{ fontSize: 'clamp(0.55rem, 2.3vw, 0.75rem)', whiteSpace: 'nowrap' }}>
      <React.Fragment>
        {icon
          ? <i className={icon} style={{ marginRight: '0.35em' }} />
          : <img src={PreApproved} alt="Preapproved" />
        }
        {verbiage}
      </React.Fragment>
    </span>
  )
}

PreApprovedBadge.propTypes = {
  visible: PropTypes.bool,
  text: PropTypes.string,
  icon: PropTypes.string,
  darkText: PropTypes.bool,
  productCode: PropTypes.string,
  onlineOnly: PropTypes.bool,
}
